module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_warning_large-7c91b1f730c661a9ac4d4c67924a2aa2.png";